import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
const basename = process.env.REACT_APP_BASE_PATH || '/';
console.log("Current Base Path:", process.env.REACT_APP_BASE_PATH);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( 
    <BrowserRouter basename={basename}>
    <App />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
